'use strict';
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require('../modules/es.data-view.constructor');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.data-view.js
// module id = 362
// module chunks = 0